/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetDownloadIcon24Regular = forwardRef('NetDownloadIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12 1.75a.75.75 0 0 1 .75.75v13.589c.086-.05.17-.11.246-.178l5.256-4.672a.75.75 0 0 1 .996 1.122l-5.255 4.67a3 3 0 0 1-3.986 0l-5.255-4.67a.75.75 0 0 1 .996-1.122l5.256 4.672c.077.069.16.128.246.178V2.5a.75.75 0 0 1 .75-.75Z" }),
        React.createElement("path", { d: "M2.75 21a.75.75 0 0 1 .75-.75h17a.75.75 0 0 1 0 1.5h-17a.75.75 0 0 1-.75-.75Z" })));
});
